import { render } from "./NotaFiscalDetalhesPagamento.vue?vue&type=template&id=fbf56d28&ts=true"
import script from "./NotaFiscalDetalhesPagamento.vue?vue&type=script&lang=ts"
export * from "./NotaFiscalDetalhesPagamento.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__